import * as React from "react";
import type { SVGProps } from "react";
const SvgLogoLattice = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 152 48"
    {...props}
  >
    <g
      fillRule="evenodd"
      clipPath="url(#Logo_Lattice_svg__a)"
      clipRule="evenodd"
    >
      <path
        fill="#16B8A2"
        d="m12.275 29.992-6.69-6.721a2.9 2.9 0 0 0-4.117 0 2.934 2.934 0 0 0 0 4.136l8.749 8.79a2.9 2.9 0 0 0 4.117 0l8.235-8.274-4.117-4.136z"
      />
      <path
        fill="#FFB41F"
        d="M37.494 17.067 24.629 29.992 11.761 17.066a2.9 2.9 0 0 0-4.118 0 2.934 2.934 0 0 0 0 4.136L22.57 36.196a2.9 2.9 0 0 0 4.117 0l14.924-14.992a2.935 2.935 0 0 0 0-4.137 2.9 2.9 0 0 0-4.117 0"
      />
      <path
        fill="#F56358"
        d="m47.788 27.409-8.748 8.788a2.9 2.9 0 0 1-4.117 0l-21.102-21.2a2.934 2.934 0 0 1 0-4.135 2.9 2.9 0 0 1 4.117 0l19.043 19.13 6.69-6.72a2.9 2.9 0 0 1 4.117 0 2.935 2.935 0 0 1 0 4.137"
      />
      <path
        fill="#16B8A2"
        d="M35.435 10.863a2.9 2.9 0 0 0-4.118 0L18.452 23.788l4.117 4.136L35.435 15a2.934 2.934 0 0 0 0-4.137"
      />
      <path
        fill="#0E0E29"
        d="M63.712 12.883h-3.58v21.126h13.117v-3.19h-9.537zm17.286 6.352c2.176 0 3.637.891 4.439 1.983l.172-1.696h3.093V34.01H85.61l-.172-1.696c-.802 1.093-2.263 1.984-4.44 1.984-3.923 0-6.587-3.19-6.587-7.531 0-4.37 2.664-7.531 6.588-7.531m.744 3.047c-2.234 0-3.838 1.753-3.838 4.484s1.604 4.484 3.838 4.484c1.719 0 2.75-.92 3.523-2.156v-4.656c-.773-1.236-1.804-2.156-3.523-2.156m15.625-7.617H93.93v4.857h-2.72v2.932h2.72v6.439c0 3.507 2.09 5.404 5.385 5.404 1.432 0 2.491-.403 3.207-.862l-.916-2.702c-.43.258-1.06.46-1.976.46-1.347 0-2.263-.863-2.263-2.329v-6.41h4.353v-2.932h-4.353zm11.844 0h-3.437v4.857h-2.721v2.932h2.721v6.439c0 3.507 2.091 5.404 5.385 5.404 1.432 0 2.491-.403 3.207-.862l-.916-2.702c-.43.258-1.06.46-1.976.46-1.347 0-2.263-.863-2.263-2.329v-6.41h4.353v-2.932h-4.353zm10.899 4.857h-3.437V34.01h3.437zm-1.719-6.754c-1.203 0-2.119.89-2.119 2.127s.916 2.127 2.119 2.127c1.232 0 2.148-.891 2.148-2.127s-.916-2.127-2.148-2.127m12.103 6.467c-4.44 0-7.39 3.162-7.39 7.53 0 4.341 2.979 7.532 7.418 7.532 2.606 0 4.582-1.179 5.871-3.19l-2.463-1.927c-.688 1.15-1.804 2.099-3.379 2.099-2.549 0-3.953-1.984-3.953-4.513 0-2.558 1.346-4.513 3.924-4.513 1.604 0 2.663.92 3.322 2.07l2.492-1.897c-1.289-2.012-3.208-3.191-5.842-3.191m14.306 0c4.44 0 6.617 3.334 6.617 7.387v1.207H141.22c.086 2.3 1.461 3.565 3.866 3.565 1.69 0 2.922-.748 3.581-1.667l2.377 1.954c-1.433 1.725-3.322 2.616-5.986 2.616-4.467 0-7.332-3.162-7.332-7.502 0-4.37 2.922-7.56 7.074-7.56m-.057 2.76c-2.033 0-3.409 1.35-3.523 3.362h6.817c-.086-1.983-1.232-3.363-3.294-3.363"
      />
    </g>
    <defs>
      <clipPath id="Logo_Lattice_svg__a">
        <path
          fill="#fff"
          d="M.615 0h151v48h-151z"
        />
      </clipPath>
    </defs>
  </svg>
);
export default SvgLogoLattice;
